export default __webpack_public_path__ + "static/101-8959181dcea4206e8054f414a9d0aefd.jpg";